import { Outlet } from "react-router-dom";

const Login = () => {
  return (
    <>
      <Outlet />
    </>
  );
};

export default Login;
